

export const GET_ORDERS_OF_USER='GET_ORDERS_OF_USER'
export const GET_ORDERS_OF_USER_SUCCESS= 'GET_ORDERS_OF_USER_SUCCESS'
export const GET_ORDERS_OF_USER_ERROR='GET_ORDERS_OF_USER_ERROR'

export const GetOrdersOfUser= (data) => ({
    type: GET_ORDERS_OF_USER,
    payload: data
});
